export function lapToSeconds(lap) {
  if (!lap) return null;
  const s = String(lap).trim().replace(",", ".");
  const parts = s.split(":");
  const nums = parts.map(Number);
  if (nums.some((n) => Number.isNaN(n))) return null;
  if (nums.length === 1) return nums[0];
  if (nums.length === 2) return nums[0] * 60 + nums[1];
  return null;
}

export function gearRatio(sprocket, pinion) {
  const c = parseFloat(sprocket);
  const p = parseFloat(pinion);
  if (!c || !p) return null;
  return (c / p).toFixed(3);
}

export function pressureDelta(cold, hot) {
  if (cold == null || hot == null || cold === "" || hot === "") return null;
  return Number(hot) - Number(cold);
}

export function formatDate(iso, lang) {
  if (!iso) return "";
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString(lang === "it" ? "it-IT" : "en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export const EVENT_TYPES = ["FIA", "COTF", "WSK", "NATIONAL", "REGIONAL", "ONE_MAKE", "TROPHY", "TEST", "OTHER"];

export const TYRES = ["fl", "fr", "rl", "rr"];

export const WEATHER = ["sunny", "partly_cloudy", "cloudy", "drizzle", "rain", "mixed"];

export const GENERAL_SETUP_FIELDS = ["rims", "front_hubs", "rear_hubs"];
export const FRONT_FIELDS = ["height", "camber", "toe", "caster", "bar", "column", "column_mount", "width"];
export const REAR_FIELDS = ["height", "axle", "width", "seat_supports", "seat_height", "seat_type"];

export function sessionBestSeconds(s) {
  const laps = [s.best_lap, s.pit ? s.best_lap2 : null].map(lapToSeconds).filter((x) => x);
  return laps.length ? Math.min(...laps) : null;
}

export function emptySession() {
  const blank = (keys) => Object.fromEntries(keys.map((k) => [k, ""]));
  const blankTyres = () => Object.fromEntries(TYRES.map((k) => [k, { cold: null, hot: null }]));
  return {
    name: "",
    category: "",
    driver: "",
    notes: "",
    best_lap: "",
    chassis_id: null,
    engine_id: null,
    track_id: null,
    session_date: "",
    session_time: "",
    front: blank(FRONT_FIELDS),
    setup_general: blank(GENERAL_SETUP_FIELDS),
    rear: blank(REAR_FIELDS),
    gear: { sprocket: "", pinion: "" },
    pit: false,
    best_lap2: "",
    tyre_set_id: null,
    tyre_set2_id: null,
    tyre_brand: "",
    tyre_model: "",
    tyre_brand2: "",
    tyre_model2: "",
    laps: "",
    laps2: "",
    tyres: blankTyres(),
    tyres2: blankTyres(),
    conditions: { weather: "", air_temp: null, track_temp: null, humidity: null, wind_speed: null, wind_deg: null, pressure: null },
    pressure_unit: "bar",
    lap_data: null,
    lap_data2: null,
  };
}
